import { Role } from '../../@paco/entities/Role/Role'

export const hasCurrentUserRoleToEditEntity = (
    currentUserRole: Role,
    otherEntityRoles: Role[],
): boolean => otherEntityRoles
    .filter(otherEntityRole => currentUserRole.priority >= otherEntityRole.priority)
    .some(Boolean)
